"use client"

import {
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "@/components/ui/dropdown-menu"
import {
  EVALUATION_DASHBOARD_OPERATIONS_APPROACHES,
  EVALUATION_DASHBOARD_PRIMARY_APPROACHES,
  evaluationDashboardApproachMenuLabel,
  setEvaluationDashboardApproach,
  useEvaluationDashboardApproach,
  type EvaluationDashboardApproach,
} from "@/hooks/use-evaluation-dashboard-approach"

function ApproachRadioItem({
  label,
  description,
  value,
}: {
  label: string
  description: string
  value: EvaluationDashboardApproach
}) {
  return (
    <DropdownMenuRadioItem value={value} className="items-start gap-2 py-2">
      <span className="flex flex-col gap-0.5">
        <span className="font-medium">{label}</span>
        <span className="text-xs leading-snug text-muted-foreground">{description}</span>
      </span>
    </DropdownMenuRadioItem>
  )
}

export function EvaluationDashboardApproachMenu() {
  const approach = useEvaluationDashboardApproach()
  const activeOperations = EVALUATION_DASHBOARD_OPERATIONS_APPROACHES.find(
    option => option.id === approach,
  )

  const handleApproachChange = (value: string) => {
    setEvaluationDashboardApproach(value as EvaluationDashboardApproach)
  }

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <i className="fa-light fa-chart-line" aria-hidden="true" />
        Evaluations dashboard
        <span className="ms-auto pe-1 text-xs text-muted-foreground">
          {evaluationDashboardApproachMenuLabel(approach)}
        </span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="w-64">
        <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">
          Surveys and Course Evaluations
        </DropdownMenuLabel>
        <DropdownMenuRadioGroup value={approach} onValueChange={handleApproachChange}>
          {EVALUATION_DASHBOARD_PRIMARY_APPROACHES.map(option => (
            <ApproachRadioItem
              key={option.id}
              value={option.id}
              label={option.label}
              description={option.description}
            />
          ))}
        </DropdownMenuRadioGroup>
        <DropdownMenuSub>
          <DropdownMenuSubTrigger className="py-2">
            <span className="font-medium">Operation</span>
            {activeOperations ? (
              <span className="ms-auto pe-1 text-xs text-muted-foreground">
                {activeOperations.label}
              </span>
            ) : null}
          </DropdownMenuSubTrigger>
          <DropdownMenuSubContent className="w-64">
            <DropdownMenuRadioGroup value={approach} onValueChange={handleApproachChange}>
              {EVALUATION_DASHBOARD_OPERATIONS_APPROACHES.map(option => (
                <ApproachRadioItem
                  key={option.id}
                  value={option.id}
                  label={option.label}
                  description={option.description}
                />
              ))}
            </DropdownMenuRadioGroup>
          </DropdownMenuSubContent>
        </DropdownMenuSub>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  )
}
